// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"764":"3b946bd3","2770":"3b946bd3","6786":"7cee071d","8165":"7cee071d","9142":"3b946bd3"}[chunkId] + ".chunk.css";
};